// import React, { useState, useEffect, useCallback } from "react";
// import { Typography, Button, TextField, Grid, FormGroup } from "@mui/material";
// import useStyles from "./style";
// import { useFormik } from "formik";
// import * as yup from "yup";
// import { showLoader, hideLoader } from "Redux/Loader/actions";
// import { showSnackbar } from "Redux/SnackBar/actions";
// import { useDispatch, useSelector } from "react-redux";
// import _ from "lodash";

// //Api routes
// import settingsApi from "Services/Settings";

// const Settings = () => {
//   const classes = useStyles();
//   const dispatch = useDispatch();

//   const demoaccount_id = useSelector(
//     (state) => state?.AuthReducer?.demoaccount_id || ""
//   );
//   const userId = useSelector(
//     (state) => state?.AuthReducer?.userid || ""
//   );

//   // States
//   const [values, setValues] = useState([]);


//   const handleSettings = (formValues) => {
//     dispatch(showLoader("Loading please wait..."));

//     const data = {
//       platform_fee_due: formValues?.platform_fee_due,
//       demoaccount_id: demoaccount_id || "",
//       platform_fee_due: userId || "",
//     };
//     const onSuccess = (res) => {
//       dispatch(hideLoader());
//       if (res?.data?.status === true) {
//         dispatch(
//           showSnackbar({
//             message: res?.data?.message || "Updated Commission settings successfully",
//             autoHideDuration: 3000,
//             anchorOrigin: {
//               vertical: "top",
//               horizontal: "right",
//             },
//             variant: "success",
//           })
//         );
//         formik?.resetForm();
//         setValues(null);
//         getMasterValues();
//       }
//     };
//     const onFailure = (err) => {
//       dispatch(hideLoader());
//       dispatch(
//         showSnackbar({
//           message: err?.response?.data?.message || "Error while update settings",
//           autoHideDuration: 3000,
//           anchorOrigin: {
//             vertical: "top",
//             horizontal: "right",
//           },
//           variant: "error",
//         })
//       );
//       //console.log("settings value update api", err);
//     };
//     settingsApi.updatePlatformSettings({ ...data }).then(onSuccess, onFailure);
//   };

//   const formik = useFormik({
//     initialValues: {
//       platform_fee_due: "0",
//       demoaccount_id: "",
//       userId: ""
//     },
//     enableReinitialize: true,
//     validationSchema: yup.object({
//       platform_fee_due: yup
//         .number()
//         .typeError("Must be a number")
//         .min(0, "Must be greater than or equal to 0")
//         .nullable(),
//     }),
//     onSubmit: handleSettings,
//   });

//   // Get Payment Settings
//   const getMasterValues = useCallback(() => {
//     dispatch(showLoader("Loading please wait..."));
//     const params = {};
//     if (demoaccount_id) {
//       params.demoaccountid = demoaccount_id;
//     }
//     const onSuccess = (res) => {
//       //console.log("payment settings details ", res.data);

//       dispatch(hideLoader());
//       if (res?.data?.status === true) {
//         setValues(res?.data?.data);
//       } else {
//         setValues([]);
//       }
//     };
//     const onFailure = (err) => {
//       dispatch(hideLoader());
//       dispatch(
//         showSnackbar({
//           message: err?.response?.data?.message || "Failed to fetch data",
//           autoHideDuration: 3000,
//           anchorOrigin: {
//             vertical: "top",
//             horizontal: "right",
//           },
//           variant: "error",
//         })
//       );
//     };
//     settingsApi.getPlatformSettings(params).then(onSuccess, onFailure);
//   }, [demoaccount_id]);

//   useEffect(() => {
//     getMasterValues();
//   }, [getMasterValues]);

//   // Formik - Set fetched values for master
//   useEffect(() => {
//     if (!_.isEmpty(values)) {
//       formik.setFieldValue("platform_fee_due", values?.platform_fee_due);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [values]);

//   return (
//     <>
//       <Grid container className={classes.cardContainer}>
//         <Grid
//           item
//           xs={12}
//           md={12}
//           lg={12}
//           xl={12}
//           className={classes.container}
//         >
//           <div style={{ padding: "15px" }}>
//             <Typography variant="h5">Admin Commission Settings</Typography>
//           </div>
//         </Grid>

//         <Grid item xs={12} md={6} lg={6} xl={6} className={classes.container}>
//           {/* Platform fee */}
//           <Grid
//             item
//             xs={12}
//             md={6}
//             lg={12}
//             xl={12}
//             className={classes.fieldWrapper}
//           >
//             <TextField
//               name="platform_fee_due"
//               id="platform_fee_due"
//               value={formik?.values?.platform_fee_due}
//               defaultValue={formik?.values?.platform_fee_due}
//               onChange={formik?.handleChange}
//               type={"text"}
//               fullWidth
//               variant="outlined"
//               size="small"
//               label="Commission Percentage (%) "
//               error={
//                 formik?.errors?.platform_fee_due && formik?.touched?.platform_fee_due
//               }
//               helperText={
//                 formik?.errors?.platform_fee_due &&
//                 formik?.touched?.platform_fee_due &&
//                 formik?.errors?.platform_fee_due
//               }
//             />
//           </Grid>
 
//         </Grid>

//         <Grid
//           item
//           xs={12}
//           md={6}
//           lg={6}
//           xl={6}
//           className={classes.container}
//         ></Grid>
//         <Grid item xs={12} md={6} lg={12} xl={12} className={classes.btn}>
//           <Button variant="contained" onClick={formik.handleSubmit}>
//             Update
//           </Button>
//         </Grid>
//       </Grid>
//     </>
//   );
// };

// export default Settings;




import React, { useEffect, useCallback, useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  InputAdornment,
  Button,
} from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { showLoader, hideLoader } from 'Redux/Loader/actions';
import { showSnackbar } from 'Redux/SnackBar/actions';
import _ from 'lodash';

//Api routes
import settingsApi from 'Services/Settings';

const AdminCommissionSettings = () => {
  const dispatch = useDispatch();

  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ''
  );
  const userId = useSelector(
    (state) => state?.AuthReducer?.userid || ''
  );

  // States
  const [values, setValues] = useState(null);

  const handleSettings = (formValues) => {
    dispatch(showLoader('Loading please wait...'));

    const data = {
      platform_fee_due: formValues?.platform_fee_due,
      demoaccount_id: demoaccount_id || '',
      userId: userId || '', // Fixed: was platform_fee_due before
    };

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || 'Updated Commission settings successfully',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
            variant: 'success',
          })
        );
        getMasterValues(); // refresh
      } else {
        dispatch(
          showSnackbar({
            message: res?.data?.message || 'Failed to update',
            variant: 'error',
          })
        );
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || 'Error while updating settings',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
          variant: 'error',
        })
      );
    };
    settingsApi.updatePlatformSettings({...data }).then(onSuccess, onFailure);
  };

  const formik = useFormik({
    initialValues: {
      platform_fee_due: '15.00', // default
      demoaccount_id: '',
      userId: '',
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      platform_fee_due: yup
       .number()
       .typeError('Must be a number')
       .min(0, 'Must be greater than or equal to 0')
       .max(100, 'Must be less than or equal to 100')
       .required('Commission is required'),
    }),
    onSubmit: handleSettings,
  });

  // Get Payment Settings
  const getMasterValues = useCallback(() => {
    dispatch(showLoader('Loading please wait...'));
    const params = {};
    if (demoaccount_id) {
      params.demoaccountid = demoaccount_id;
    }
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setValues(res?.data?.data);
      } else {
        setValues(null);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || 'Failed to fetch data',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
          variant: 'error',
        })
      );
    };
    settingsApi.getPlatformSettings(params).then(onSuccess, onFailure);
  }, [demoaccount_id, dispatch]);

  useEffect(() => {
    getMasterValues();
  }, [getMasterValues]);

  // Set fetched values to formik
  useEffect(() => {
    if (!_.isEmpty(values)) {
      formik.setFieldValue('platform_fee_due', values?.platform_fee_due || '0');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  const inputSx = {
    width: { xs: '100%', sm: 300 },
    '&.MuiOutlinedInput-root': {
      backgroundColor: '#F9FAFB',
      borderRadius: 2,
      fontSize: 14,
      '& fieldset': { border: 'none' },
    },
  };

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#F4F6F9', p: { xs: 2, md: 3 } }}>
      <Paper
        elevation={0}
        sx={{
          borderRadius: 4,
          p: { xs: 2, md: 4 },
          minHeight: '80vh',
          boxShadow: '0px 2px 10px rgba(0,0,0,0.04)',
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 4,
          }}
        >
          <Typography sx={{ fontWeight: 700, fontSize: 20, color: '#111827' }}>
            Admin Commission Settings
          </Typography>
          <Typography sx={{ fontSize: 13, color: '#6B7280' }}>
            Admin&nbsp;&nbsp;/&nbsp;&nbsp;
            <Box component="span" sx={{ color: '#111827', fontWeight: 600 }}>
              Admin Commission Settings
            </Box>
          </Typography>
        </Box>

        {/* Form */}
        <Box component="form" onSubmit={formik.handleSubmit}>
          <Typography sx={{ fontWeight: 500, fontSize: 14, color: '#374151', mb: 1 }}>
            Commission Percentage (%)
          </Typography>
          <TextField
            name="platform_fee_due"
            
            id="platform_fee_due"
            type="number"
            value={formik.values.platform_fee_due}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            size="small"
            error={formik.touched.platform_fee_due && Boolean(formik.errors.platform_fee_due)}
            helperText={formik.touched.platform_fee_due && formik.errors.platform_fee_due}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Typography sx={{ fontWeight: 600, fontSize: 14, color: '#0e1014' }}>%</Typography>
                </InputAdornment>
              ),
            }}
            inputProps={{ step: "0.01", min: 0, max: 100 }}
            sx={inputSx}
          />

          {/* Update Button */}
          <Box sx={{ mt: 3 }}>
            <Button
              type="submit"
              variant="contained"
              disableElevation
            
              sx={{
                backgroundColor: '#000',
                color: '#fff',
                borderRadius: 2,
                px: 5,
                py: 1.2,
                textTransform: 'none',
                fontWeight: 600,
                fontSize: 14,
                width: 180,
                '&:hover': { backgroundColor: '#1F2937' },
              }}
            >
              Update
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default AdminCommissionSettings;
